export default __webpack_public_path__ + "static/media/image32tum.313c4753.jpg";